// Lib
import { FC, memo } from "react";
import { Select } from "antd";
// Icons
import { DownArrowIcon } from "icons";
// Styled
import { PaginationContainer, StyledPagination, Wrapper } from "./styled";
import { useViewport } from "hooks";

const defaultOptions = [
  {
    value: 10,
    label: "10",
  },
  {
    value: 25,
    label: "25",
  },
  {
    value: 50,
    label: "50",
  },
  {
    value: 500,
    label: "500",
  },
  {
    value: 1000,
    label: "1000",
  },
];

interface PaginationProps {
  limit: number;
  page: number;
  setLimit: (arg: number) => void;
  setPage: (arg: number) => void;
  shadow?: boolean;
  padding?: string;
  onPage?: boolean;
  showSizeChanger?: boolean;
  pageSizeOptions?: {
    value: number;
    label: string;
  }[];
  additinalSizeOptions?: {
    value: number;
    label: string;
  }[];
  totalItems?: number;
}

const PaginationComponent: FC<PaginationProps> = ({
  padding,
  shadow,
  onPage,
  showSizeChanger,
  limit,
  page,
  setLimit,
  setPage,
  pageSizeOptions,
  totalItems,
}) => {
  const { isDesktop } = useViewport();

  const handleChange = (value: number) => {
    setLimit(value);
  };

  const onPageChange = (page: number, pageSize: number) => {
    setPage(page);

    if (!isDesktop && pageSize !== limit) {
      setLimit(pageSize);
    }
  };

  const getCurrentOrder = () => {
    const startItem = (page - 1) * limit + 1;
    const endItem = Math.min(page * limit, totalItems);
    return `${startItem}-${endItem} of ${totalItems}`;
  };

  const currentItemsOrder = totalItems && getCurrentOrder();

  return (
    <Wrapper
      $align="center"
      $justify="space-between"
      $shadow={shadow}
      $onPage={onPage}
      $desktop={isDesktop}
      $padding={padding}
    >
      {isDesktop && (
        <div>
          <Select
            suffixIcon={<DownArrowIcon />}
            defaultValue={10}
            value={limit}
            style={{ width: 85, marginRight: 10 }}
            onChange={handleChange}
            options={
              pageSizeOptions ||
              defaultOptions.concat({ label: "All", value: totalItems })
            }
          />
          Rows per page
        </div>
      )}

      <PaginationContainer $responsive={!isDesktop}>
        <StyledPagination
          current={page}
          pageSize={limit}
          onChange={onPageChange}
          showSizeChanger={showSizeChanger}
          responsive={!isDesktop}
          total={totalItems}
        />
      </PaginationContainer>

      {isDesktop && totalItems ? <div>{currentItemsOrder}</div> : <div />}
    </Wrapper>
  );
};

export const Pagination = memo(PaginationComponent);
